import apiClient from "./api-client";
import StorageHelper from '../utils/storage-helper';

const API = process.env.REACT_APP_DOVESAPI + 'authenticate/2fa/';

const getHeaders = () => ({
  headers: {
    Authorization: 'Bearer ' + StorageHelper.get('token'),
    'Content-Type': 'application/json'
  }
});

export const enable2FA = async () => {
  return apiClient.post(`${API}enable`, null, getHeaders());
};

export const disable2FA = async () => {
  return apiClient.post(`${API}disable`, null, getHeaders());
};
